import { useMicrocopy } from '@contexts/MicrocopyContext';
import { AtomicContext } from '@contexts/coveo/AtomicContext';
import { MicrocopyFragment } from '@graphql/generated-contentful/graphql';
import { CaretDown } from 'phosphor-icons';
import { useContext } from 'react';
import { useResults } from './hooks/useResults';
import { useResultsPerPage } from './hooks/useResultsPerPage';

const RESULTS_PER_PAGE_OPTIONS = [24, 48, 96];

export const ResultsPerPage = ({ context }: { context: AtomicContext }) => {
  const { searchEngine } = useContext(context);
  const { resultsPerPage, setResultsPerPage } = useResultsPerPage(searchEngine);
  const { results: resultState } = useResults(searchEngine);
  const shouldDisplay = resultState?.results && resultState.results.length > 0;
  const { searchLabelsMicrocopy } = useMicrocopy<{
    searchLabelsMicrocopy: MicrocopyFragment[];
  }>();
  const resultsPerPageLabel =
    searchLabelsMicrocopy.find(
      (microcopyFragment) => microcopyFragment.key === 'search.results-per-page'
    )?.value ?? 'Results';

  if (!shouldDisplay) {
    return null;
  }

  return (
    <label>
      <div className="tiny-text mb-2 text-grey-600">{resultsPerPageLabel}</div>
      <div className="relative">
        <select
          data-test="search-results-per-page-select"
          className="focus-outline tiny-text h-10 cursor-pointer appearance-none rounded-lg border border-grey-400 bg-grey-100 pl-3 pr-6 font-medium text-grey-600 hover:text-grey-700 focus:bg-white focus:text-grey-700"
          value={resultsPerPage}
          onChange={(e) => setResultsPerPage(parseInt(e.target.value, 10))}
        >
          {RESULTS_PER_PAGE_OPTIONS.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute right-2 top-0 flex h-full items-center justify-center">
          <CaretDown size={15} className="pointer-events-none text-grey-600" />
        </div>
      </div>
    </label>
  );
};
